import { createSlice } from "@reduxjs/toolkit";
import { cmsSettings as initialState } from "../initialState";
import {
    selectCmsSettingsSelector,
    selectContainersByPageSelector,
    selectCmsControlsByPageSelector,
    selectCmsControlByIdByPageSelector,
    selectCmsControlByTypeSelector,
    selectCmsControlByIdSelector,
    selectThemeSettingsSelector,
    selectCmsOptionByTypeSelector,
} from "../selectors/cmsSettingsSelectors";

import {
    updateControlAction,
    updateThemeAction,
} from "../actions/cmsSettingsActions";

export const slice = createSlice({
    name: "cmsSettings",
    initialState,
    reducers: {
        updateControls: updateControlAction,
        updateTheme: updateThemeAction,
    },
});

// actions
export const { updateControls, updateTheme } = slice.actions;

// selectors

// getCmsSettings
export const selectCmsSettings = (state) => selectCmsSettingsSelector(state);

// getContainersByPage
export const selectContainersByPage = (state, page) =>
    selectContainersByPageSelector(state, page);

// getCmsControlsByPage
export const selectCmsControlsByPage = (state, page) =>
    selectCmsControlsByPageSelector(state, page);

// getCmsControlByIdByPage
export const selectCmsControlByIdByPage = (id, page, state) =>
    selectCmsControlByIdByPageSelector(id, page, state);

// getCmsControlByType
export const selectCmsControlByType = (cmsControlEnum, state) =>
    selectCmsControlByTypeSelector(cmsControlEnum, state);

// getCmsControlById
export const selectCmsControlById = (id, state) =>
    selectCmsControlByIdSelector(id, state);

// getThemeSettings
export const selectThemeSettings = (theme, state) =>
    selectThemeSettingsSelector(theme, state);

// getCmsOptionByType
export const selectCmsOptionByType = (type, option, state) =>
    selectCmsOptionByTypeSelector(type, option, state);

export default slice.reducer;
